export const COUPON_ALL='coupon_all'
export const COUPON_LOCAL='coupon_local'
export const COUPON_REMOTE='coupon_remote'
export const BALANCE='balance'
export const PARTICIPANT='participant'
export const DECLINE='decline'
export const FREE='free'
